import { Stack, Typography } from "@mui/material";
import { PopupContainer } from "../../components/popup";

export const PolicyPopup = ({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) => {
  if (!visible) return null;

  return (
    <PopupContainer onClose={onClose} title="Membership & Renewal Policy">
      <Stack spacing={2}>
        <Typography variant="body1">
          Homeowner memberships renew automatically at the end of each billing
          period. The <strong>Guild</strong> plan is billed monthly and{" "}
          <strong>Guild&nbsp;+</strong> is billed annually, as shown on the plan
          cards.
        </Typography>
        <Typography variant="body1">
          You can change plans or turn off auto-renew any time in your account
          before the next renewal date. The <strong>Basic</strong> plan is free.
        </Typography>
        <Typography variant="body1">
          Taxes and any promotional terms will be shown at checkout. For billing
          questions, contact support and we’ll be happy to help.
        </Typography>
      </Stack>
    </PopupContainer>
  );
};
